import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RunIdSchema } from "../primitives/ids.js";
/** site-export-manifest.v1.0 — Tier 0 Step 4 static site bundle index (worker-written). */
export const SiteExportManifestV1Schema = z
    .object({
    schemaVersion: z.literal("site-export-manifest.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    runId: RunIdSchema,
    artifactSetHash: z.string().min(1),
    indexRelativePath: z.literal("site/index.html"),
    manifestRelativePath: z.literal("site/manifest.json"),
    generatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=site-export-manifest.js.map